var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#407EDB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14C27.5 14.6904 26.9404 15.25 26.25 15.25C26.0893 15.25 25.9358 15.2197 25.7947 15.1645L23.4145 17.5447C23.4697 17.6858 23.5 17.8393 23.5 18C23.5 18.6904 22.9404 19.25 22.25 19.25C21.5596 19.25 21 18.6904 21 18C21 17.8393 21.0303 17.6857 21.0855 17.5446L19.7054 16.1645C19.5643 16.2197 19.4107 16.25 19.25 16.25C19.0893 16.25 18.9358 16.2197 18.7947 16.1645L15.4145 19.5447C15.4697 19.6858 15.5 19.8393 15.5 20C15.5 20.6904 14.9404 21.25 14.25 21.25C13.5596 21.25 13 20.6904 13 20C13 19.3096 13.5596 18.75 14.25 18.75C14.4118 18.75 14.5664 18.7807 14.7083 18.8367L18.0867 15.4583C18.0307 15.3164 18 15.1618 18 15C18 14.3096 18.5596 13.75 19.25 13.75C19.9404 13.75 20.5 14.3096 20.5 15C20.5 15.1617 20.4693 15.3163 20.4134 15.4582L21.7918 16.8366C21.9337 16.7807 22.0883 16.75 22.25 16.75C22.4118 16.75 22.5664 16.7807 22.7083 16.8367L25.0867 14.4583C25.0307 14.3164 25 14.1618 25 14C25 13.3096 25.5596 12.75 26.25 12.75C26.9404 12.75 27.5 13.3096 27.5 14Z",
    fill: "#41444A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10C10.2314 10 9 11.2344 9 12.75V23.25C9 24.0156 9.3125 24.7109 9.81641 25.2031C10.3125 25.6953 10.9961 26 11.75 26H18V28H16.5C16.2236 28 16 28.2266 16 28.5C16 28.7734 16.2236 29 16.5 29H23.5C23.6875 29 23.8506 28.8906 23.9365 28.7422C23.9766 28.6719 24 28.5859 24 28.5C24 28.2266 23.7764 28 23.5 28H22V26H28.25C29.7686 26 31 24.7656 31 23.25V21C31 20.5859 30.6641 20.25 30.25 20.25C29.8359 20.25 29.5 20.5859 29.5 21V23.25C29.5 23.9375 28.9404 24.5 28.25 24.5H11.75C11.0596 24.5 10.5 23.9375 10.5 23.25V23H28.5C28.7764 23 29 22.7734 29 22.5C29 22.2266 28.7764 22 28.5 22H10.5V12.75C10.5 12.2812 10.7578 11.875 11.1396 11.6562C11.3203 11.5547 11.5283 11.5 11.75 11.5H28.25C28.9404 11.5 29.5 12.0625 29.5 12.75V18C29.5 18.4141 29.8359 18.75 30.25 18.75C30.6641 18.75 31 18.4141 31 18V12.75C31 11.2344 29.7686 10 28.25 10H11.75Z",
    fill: "#41444A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.88d410a76f497b67a415d46c65aa3a16.svg";
export { ForwardRef as ReactComponent };